import { useMutation } from '@tanstack/react-query';
import { switchToFreePlan } from '../../services/subscriptions';
import { SwitchToFreePlanResponse } from '../../types/subscriptions';

interface Options {
  onSuccess?: (data: SwitchToFreePlanResponse) => void;
  onError?: (error: Error) => void;
}

function useSwitchToFreePlan({ onSuccess, onError }: Options = {}) {
  return useMutation({
    mutationFn: switchToFreePlan,
    onSuccess,
    onError,
  });
}

export default useSwitchToFreePlan;
